import React from 'react';
import { TIER_LEVELS } from '../utils/tierSystem.js';
import { FaCrown, FaGem, FaMedal, FaStar } from 'react-icons/fa';

const TierIcon = ({ tier = 'STANDARD', size = 'md' }) => {
  const tierInfo = TIER_LEVELS[tier];
  
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const getIcon = () => {
    switch (tier) {
      case 'DIAMOND':
        return <FaGem className={`${sizeClasses[size]} transition-all`} style={{ color: tierInfo.color }} />;
      case 'PLATINUM':
        return <FaCrown className={`${sizeClasses[size]} transition-all`} style={{ color: tierInfo.color }} />;
      case 'GOLD':
        return <FaMedal className={`${sizeClasses[size]} transition-all`} style={{ color: tierInfo.color }} />;
      case 'SILVER':
        return <FaStar className={`${sizeClasses[size]} transition-all`} style={{ color: tierInfo.color }} />;
      default:
        return null;
    }
  };

  const icon = getIcon();
  if (!icon) return null;

  return (
    <div 
      className="inline-flex items-center justify-center tooltip-container"
      title={`${tierInfo.name} Tier`}
    >
      {icon}
    </div>
  );
};

export default TierIcon; 